import { push } from 'react-router-redux';
import * as analytics from '../../utils/analytics';

const pushRouteMiddleware = ({ dispatch }) => (next) => (action) => {
  const result = next(action);
  if (action.path) {
    dispatch(push(action.path));
    analytics.updatePageName(action.path);
  }
  return result;
};
export default pushRouteMiddleware;
